import { render, staticRenderFns } from "./layout_aside.vue?vue&type=template&id=f07156dc&scoped=true&"
import script from "./layout_aside.vue?vue&type=script&lang=js&"
export * from "./layout_aside.vue?vue&type=script&lang=js&"
import style0 from "./layout_aside.vue?vue&type=style&index=0&id=f07156dc&lang=scss&scoped=true&"
import style1 from "./layout_aside.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07156dc",
  null
  
)

export default component.exports